import { CalendarContainerStyles } from './CalendarContainer.types'

const makeStyles = (): CalendarContainerStyles => ({
	container: ({
		backgroundColor: '#FFF0BA',
		border: '1px solid black'
	})
})

export default makeStyles
